"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactJsonView = _interopRequireDefault(require("react-json-view"));

var _ReactTablev = _interopRequireDefault(require("@cimpress/react-components/lib/ReactTablev6"));

var _filterCaveats = require("../../helpers/filterCaveats");

var _AccordionWrapper = _interopRequireDefault(require("../AccordionWrapper"));

var _core = require("@emotion/core");

var columns = [{
  Header: 'Code',
  accessor: 'code',
  Cell: function Cell(_ref) {
    var value = _ref.value;
    return (0, _core.jsx)("p", null, value);
  }
}, {
  Header: 'Message',
  accessor: 'message',
  Cell: function Cell(_ref2) {
    var value = _ref2.value,
        original = _ref2.original;
    var additionalInfo = (0, _omit2["default"])(original, ['code', 'message']);
    return (0, _core.jsx)(_react["default"].Fragment, null, (0, _core.jsx)("div", {
      style: {
        marginBottom: '5px'
      }
    }, value), !(0, _isEmpty2["default"])(additionalInfo) && (0, _core.jsx)(_reactJsonView["default"], {
      src: additionalInfo,
      name: false,
      indentWidth: 2,
      displayDataTypes: false,
      displayObjectSize: false,
      enableClipboard: false,
      collapsed: true
    }));
  }
}];

var CaveatsDisplay = function CaveatsDisplay(_ref3) {
  var caveats = _ref3.caveats;
  var filteredCaveats = (0, _filterCaveats.filterCaveats)(caveats);
  return filteredCaveats.length > 0 && (0, _core.jsx)(_AccordionWrapper["default"], {
    title: "Caveats",
    variant: "minimal"
  }, (0, _core.jsx)(_ReactTablev["default"], {
    columns: columns,
    data: filteredCaveats,
    pageSize: filteredCaveats.length,
    showPagination: false,
    sortable: false,
    condensed: true
  }));
};

CaveatsDisplay.propTypes = {
  caveats: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired
};
var _default = CaveatsDisplay;
exports["default"] = _default;